import { UaaClientConfiguration } from "@com.mgmtp.a12.uaa/uaa-authentication-client";
import { RequestFilter } from "@com.mgmtp.a12.utils/utils-connector/lib/main";

import { HeaderKeys, UrlParameters } from "./const";

const injectMarkerRequestFilter: RequestFilter = {
	canHandleRequest({ payload }) {
		return !payload.customHeaders?.some(it => it[0] === HeaderKeys.marker);
	},
	doRequestFilter({ request }) {
		const urlParams = new URLSearchParams(window.location.search);
		const rawMarker = urlParams.get(UrlParameters.marker);
		const marker = rawMarker && /^[a-zA-Z0-9_-]+$/.test(rawMarker) ? rawMarker : undefined;
		if (!marker) {
			return { continue: true, request };
		}

		const headers = new Headers(request.headers);
		headers.set(HeaderKeys.marker, marker);

		return { continue: true, request: { ...request, headers } };
	}
};

export const uaaClientConfiguration: UaaClientConfiguration = {
	serverURL: `${window.location.origin}/api`,
	automaticallyLogin: true,
	additionalRequestFilter: [injectMarkerRequestFilter],
	overrideClientConfigures: {
		oidc: {
			silent_redirect_uri: `${window.location.origin}/silent_renew.html`
		}
	}
};
